const ForbiddenToCustomer: React.FC = () => (
  <h1 className="heading-sm">You don&apos;t have access to this document.</h1>
);

export default ForbiddenToCustomer;
